
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseLogo',
  props: {
    icon: { type: String },
    type: { type: String, default: 'png' }
  }
})
